import React from "react"

import Form from "./Form"

const NewAcrClass: React.FC = () => <Form />

export default NewAcrClass
